import { useEffect, useState } from "react";

const problems = [
  {
    title: "No visibility",
    description: "Clients learn about delays after they've already happened.",
  },
  {
    title: "Hidden risks",
    description: "Contractors mask issues to avoid penalties — until they're irreversible.",
  },
  {
    title: "Weak verification",
    description: "Milestones get approved without independent inspection.",
  },
  {
    title: "Lost budget",
    description: "Cost overruns of 15–40% are the norm, not the exception.",
  },
];

export function ProblemSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById("problem-section");
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="problem-section" className="relative py-24 md:py-32 lg:py-40 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-20">
          <h2
            className={`text-5xl md:text-6xl lg:text-7xl font-display tracking-tight leading-[1.1] transition-all duration-1000 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Most projects fail
            <br />
            <span className="text-muted-foreground">in plain sight.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`transition-all duration-1000 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${100 + index * 100}ms` }}
            >
              <h3 className="text-2xl md:text-3xl font-display mb-4">
                {problem.title}
              </h3>
              <p className="text-lg text-muted-foreground leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
